module.exports = __webpack_public_path__ + "static/3-8d01f30b5ab4f9c0c354edce442e6e16.png";